import React from 'react';
import PropTypes from 'prop-types';
import ClaimedByIcon from 'products/nomad_insurance/assets/img/claims/claimed-by.svg';
import { Claimant } from './styled';
import { InfoTextWrapper } from '../../styled';

const ClaimantInfo = ({ claimFullName }) => {
  return (
    <InfoTextWrapper>
      <img src={ClaimedByIcon} alt="Claimed by" />
      <Claimant>{claimFullName}</Claimant>
    </InfoTextWrapper>
  );
};

ClaimantInfo.propTypes = {
  claimFullName: PropTypes.string.isRequired
};

export default ClaimantInfo;
